import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import { parseCsv, readFileAsText } from '@/utils/csvParser';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
let CsvUploadStep = class CsvUploadStep extends Vue {
    parsing = false;
    csvHeaders = [];
    csvData = [];
    mapping = {
        instructorId: null,
        amount: null,
        tax: null,
    };
    get previewRows() {
        return this.csvData.slice(0, 5);
    }
    get isMappingValid() {
        return !!this.mapping.instructorId && !!this.mapping.amount;
    }
    async onFileChange(file) {
        if (!file) {
            this.csvHeaders = [];
            this.csvData = [];
            return;
        }
        this.parsing = true;
        try {
            const content = await readFileAsText(file);
            const rows = parseCsv(content);
            if (rows.length < 2) {
                return;
            }
            this.csvHeaders = rows[0];
            this.csvData = rows.slice(1);
        }
        finally {
            this.parsing = false;
        }
    }
    async onImport() {
        const instructors = this.$store.getters['instructor/active'];
        const idCol = this.csvHeaders.indexOf(this.mapping.instructorId);
        const amountCol = this.csvHeaders.indexOf(this.mapping.amount);
        const taxCol = this.mapping.tax ? this.csvHeaders.indexOf(this.mapping.tax) : -1;
        const rows = [];
        const errors = [];
        for (let rowIdx = 0; rowIdx < this.csvData.length; rowIdx++) {
            const csvRow = this.csvData[rowIdx];
            const rowNum = rowIdx + 2; // +2: 1-based + header row
            const instructorId = csvRow[idCol]?.trim();
            if (!instructorId) {
                errors.push(`Řádek ${rowNum}: Chybí ID instruktora`);
                continue;
            }
            const instructor = instructors.find(i => i.id === instructorId);
            if (!instructor) {
                errors.push(`Řádek ${rowNum}: Instruktor s ID '${instructorId}' nenalezen`);
                continue;
            }
            const amount = parseFloat(csvRow[amountCol]?.replace(',', '.'));
            if (isNaN(amount) || amount <= 0) {
                errors.push(`Řádek ${rowNum}: Neplatná částka`);
                continue;
            }
            let tax = taxCol >= 0 ? (parseFloat(csvRow[taxCol]?.replace(',', '.')) || 0) : 0;
            if (tax === 0 && instructor.data.paysTaxes) {
                tax = Math.round(amount * 0.15 * 100) / 100;
            }
            rows.push({
                instructorId,
                instructorName: `${instructor.data.surname} ${instructor.data.name}`,
                bankAccount: instructor.data.bankAccount || '',
                amount,
                tax,
                confirmed: false,
            });
        }
        if (errors.length > 0) {
            const errorList = errors.map(e => `<div style="color: #FB8C00">${e}</div>`).join('');
            const confirmed = await ConfirmDialog.open('Přeskočené řádky', errorList, 'Pokračovat', 'Zpět', 600);
            if (!confirmed)
                return;
        }
        this.$emit('import', rows);
    }
};
CsvUploadStep = __decorate([
    Component
], CsvUploadStep);
export default CsvUploadStep;
